import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { AdminRoster } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import { DashboardSectionState } from './DashboardSectionState';
import { ROSTER_HEADERS, ROSTER_TABLE_ARIA, RosterRow, type LineDoors } from './RosterRow';
import { RostersAdminTable, usePagedRows } from './RostersAdminTable';

const { rosters: strings } = appStrings.modules.coachingDashboard.institutionAdmin;

type RostersSectionProps = Readonly<{
  rows: readonly AdminRoster[];
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string | null;
  dropped?: number;
  doors: LineDoors;
}>;

export const RostersSection = ({
  rows,
  isLoading,
  isError,
  errorMessage,
  dropped,
  doors,
}: RostersSectionProps) => {
  const paging = usePagedRows(rows);

  return (
    <DashboardSectionState
      id="dashboard-rosters-section-state"
      isLoading={isLoading && rows.length === 0}
      isError={isError}
      errorMessage={errorMessage}
      dropped={dropped}
      isEmpty={rows.length === 0}
      strings={strings}
    >
      <RostersAdminTable
        paginationId="rosters-admin-rosters-pagination"
        headers={ROSTER_HEADERS}
        ariaLabel={ROSTER_TABLE_ARIA}
        paging={paging}
      >
        {paging.visible.map((roster) => (
          <RosterRow key={roster.id} roster={roster} doors={doors} />
        ))}
      </RostersAdminTable>
    </DashboardSectionState>
  );
};
